const ABProcessTaskServiceQueryCore = require("../../../core/process/tasks/ABProcessTaskServiceQueryCore");
module.exports = class ABProcessTaskServiceQuery extends (
   ABProcessTaskServiceQueryCore
) {};
